/**
 * Created by evgenijsenkevic on 8/7/25
 */

const LightningRushLogic = function (mission) {
    cleverapps.EventEmitter.call(this);

    this.mission = mission;

    const details = mission.details || {};
    this.state = details.state !== undefined ? details.state : LightningRushLogic.STATES.LOCKED;
    this.start = details.start;
    this.currentDay = details.day;
};

LightningRushLogic.prototype = Object.create(cleverapps.EventEmitter.prototype);
LightningRushLogic.prototype.constructor = LightningRushLogic;

LightningRushLogic.prototype.onUpdateCompetition = function () {
    if (this.state === LightningRushLogic.STATES.FINISHED || this.state === LightningRushLogic.STATES.PRIZE) {
        this.mission.stopCompetition();
    }
};

LightningRushLogic.prototype.onUpdateState = function () {
    if (this.countdown) {
        this.countdown.remove();
        delete this.countdown;
    }

    const endOfDay = new Date();
    endOfDay.setHours(24, 0, 0, 0);
    let timeLeft = endOfDay.getTime() - Date.now();

    if (this.state === LightningRushLogic.STATES.FINISHED) {
        if (this.isNewDay()) {
            this.resetCompetition();
            return;
        }
    } else if (this.state === LightningRushLogic.STATES.ACTIVE) {
        const finish = this.start + LightningRushLogic.TOURNAMENT_DURATION;
        if (Date.now() < finish) {
            timeLeft = finish - Date.now();
        } else {
            this.stopCompetition();
            return;
        }
    }

    if (timeLeft) {
        this.countdown = new cleverapps.CountDown(timeLeft, {
            onFinish: this.onUpdateState.bind(this),
            permanent: true
        });
    }
};

LightningRushLogic.prototype.calcCurrentDay = function () {
    return new Date().getDate();
};

LightningRushLogic.prototype.isNewDay = function () {
    return this.currentDay !== this.calcCurrentDay() && this.mission.isRunning();
};

LightningRushLogic.prototype.isCooldown = function () {
    return this.state === LightningRushLogic.STATES.FINISHED;
};

LightningRushLogic.prototype.isOver = function () {
    return this.isCooldown() && this.getCooldownTimeLeft() >= this.mission.getTimeLeft();
};

LightningRushLogic.prototype.getCooldownTimeLeft = function () {
    if (!this.isCooldown()) {
        return 0;
    }

    const endOfDay = new Date();
    endOfDay.setHours(24, 0, 0, 0);

    return Math.max(0, endOfDay.getTime() - Date.now());
};

LightningRushLogic.prototype.getView = function () {
    if (this.state === LightningRushLogic.STATES.LOCKED) {
        return LightningRushStartWindow;
    }

    if (cleverapps.config.type === "merge2") {
        if (this.state === LightningRushLogic.STATES.PRIZE || this.state === LightningRushLogic.STATES.FINISHED) {
            return LightningRushGardenFinishWindow;
        }
    }
    return LightningRushWindow;
};

LightningRushLogic.prototype.isPrizeState = function () {
    return this.state === LightningRushLogic.STATES.PRIZE;
};

LightningRushLogic.prototype.isActiveState = function () {
    return this.state === LightningRushLogic.STATES.ACTIVE;
};

LightningRushLogic.prototype.isAttentionRequired = function () {
    if (this.mission.runningCompetition && this.mission.runningCompetition.hasPlaceChanged()) {
        return true;
    }

    return this.state === LightningRushLogic.STATES.LOCKED;
};

LightningRushLogic.prototype.competitionTimeLeft = function () {
    if (this.isActiveState()) {
        return this.start + LightningRushLogic.TOURNAMENT_DURATION - Date.now();
    }

    if (!this.isUnlocked()) {
        return undefined;
    }

    return 0;
};

LightningRushLogic.prototype.getFinishWindow = function () {
    if (this.state === LightningRushLogic.STATES.LOCKED) {
        return;
    }

    return this.getView();
};

LightningRushLogic.prototype.setState = function (state, delta) {
    this.state = state;
    this.saveData(delta);

    this.trigger("updateStatus");
    cleverapps.missionManager.trigger("lightningRushStateChanged", this.mission);
};

LightningRushLogic.prototype.saveData = function (value) {
    this.mission.update(value || 0, {
        state: this.state,
        day: this.currentDay,
        start: this.start
    });
};

LightningRushLogic.prototype.stopCompetition = function () {
    this.mission.stopCompetition();
    this.setState(this.mission.getPrize() ? LightningRushLogic.STATES.PRIZE : LightningRushLogic.STATES.FINISHED);
};

LightningRushLogic.prototype.receivePrize = function () {
    if (this.state !== LightningRushLogic.STATES.PRIZE) {
        return;
    }

    this.mission.logEvent(Mission.EVENTS.MISSION_REWARD_VALUE, { reward: this.mission.getPrize() });

    cleverapps.focusManager.display({
        focus: "LightingRushRewardWindow",
        stack: true,
        action: (f) => {
            new RewardWindow(this.mission.getPrize(), {
                event: this.mission.name,
                toBubbleStack: true
            });
            cleverapps.focusManager.onceNoWindowsListener = f;
        }
    });

    if (this.isNewDay()) {
        this.resetCompetition();
    } else {
        this.setState(LightningRushLogic.STATES.FINISHED);
    }
};

LightningRushLogic.prototype.resetCompetition = function () {
    this.mission.clearCompetition();
    this.start = undefined;
    this.currentDay = this.calcCurrentDay();

    this.setState(LightningRushLogic.STATES.LOCKED, -this.mission.result);
};

LightningRushLogic.prototype.startCompetition = function () {
    if (this.state !== LightningRushLogic.STATES.LOCKED) {
        return;
    }

    this.start = Date.now();
    this.currentDay = this.calcCurrentDay();
    this.setState(LightningRushLogic.STATES.ACTIVE);

    cleverapps.focusManager.display({
        focus: "LightingRushWelcome",
        stack: true,
        actions: [
            function (f) {
                new RewardWindow(this.getWelcomeRewards(), {
                    event: this.mission.name,
                    title: Messages.get("LightningRushRewardWindow.Title")
                });

                cleverapps.focusManager.onceNoWindowsListener = f;
            }.bind(this),
            function (f) {
                const scenario = cleverapps.tutorial.findScenario(LightningRushTutorial.NAME);
                if (scenario && scenario.isAvailable()) {
                    cleverapps.tutorial.startScenario(scenario);
                }

                f();
            }
        ]
    });

    this.mission.updateCompetition(true);

    this.trigger("updateStatus");
};

LightningRushLogic.prototype.onChangeResults = function () {
    this.trigger("updateStatus");
};

LightningRushLogic.prototype.getWelcomeRewards = function () {
    if (cleverapps.abExperiments.getGroup(ABExperiments.Tests.energyBoosterMissions) === "A") {
        return { energyBooster: "30 minutes" };
    }

    return RewardsConfig.LightingRushWelcomeBonus;
};

LightningRushLogic.prototype.earnPoints = function (value) {
    if (this.state !== LightningRushLogic.STATES.ACTIVE) {
        return;
    }

    this.mission.logEvent(Mission.EVENTS.MISSION_POINTS, { value });

    this.saveData(value);
};

LightningRushLogic.prototype.onUpdateMission = function (value) {
    if (value > 0) {
        cleverapps.personalBest.addPoint("lightning", value);
        this.pendingDelta = (this.pendingDelta || 0) + value;
        this.trigger("updateResult", value);
    }
};

LightningRushLogic.prototype.receiveRewards = function (f) {
    const value = this.pendingDelta;
    delete this.pendingDelta;

    this.mission.receiveIncome(value, f);
};

LightningRushLogic.prototype.isUnlocked = function () {
    return this.state !== LightningRushLogic.STATES.LOCKED;
};

LightningRushLogic.prototype.getCompetitionOptions = function () {
    const finish = this.start + LightningRushLogic.TOURNAMENT_DURATION;
    return { ...Missions[Mission.TYPE_LIGHTNING_RUSH].competition, start: this.start, finish };
};

LightningRushLogic.prototype.destructor = function () {
    runCleaners(this);
};

LightningRushLogic.prototype.calcStatusInfo = function () {
    let text = Messages.get("Finished");

    if (this.state === LightningRushLogic.STATES.LOCKED) {
        text = Messages.get("SideBarPlace.Start");
    }

    if (this.state === LightningRushLogic.STATES.ACTIVE) {
        text = `%% ${this.mission.result}`;
    }

    return {
        text,
        icons: {
            "%%": this.mission.getIcon()
        }
    };
};

LightningRushLogic.prototype.receiveReward = function () {
    this.mission.rewardsReceived = true;
};

LightningRushLogic.STATES = {
    LOCKED: 0,
    ACTIVE: 1,
    PRIZE: 2,
    FINISHED: 3
};
LightningRushLogic.TOURNAMENT_DURATION = cleverapps.parseInterval("1 hour");
